import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, EditorState, convertFromHTML, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml, {} from "draftjs-to-html"; // Import the library
import { ErrorMessage } from "formik";

const RichTextEditor = ({ value, name, form, editorData }) => {

  // const { errors } = useFormikContext()
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  //   if (value) {
  //     let convertedToHTML = decodeURIComponent(value)
  //     // let contentState = convertFromHTML(value); 
  //     const blocksFromHTML = convertFromHTML(convertedToHTML);
  //     return EditorState.createWithContent(ContentState.createFromBlockArray(
  //       blocksFromHTML.contentBlocks,
  //       blocksFromHTML.entityMap
  //     ));
  //   }
  //   return EditorState.createEmpty()
  // });

  useEffect(() => {
    if (editorData) {
      let convertedToHTML = decodeURIComponent(editorData)
      // let blocksFromHTML = convertFromHTML(editorData); 
      const blocksFromHTML = convertFromHTML(convertedToHTML);
      setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      )));
    }
  }, [editorData])


  const onEditorStateChange = (newState) => {
    // if (!newState.getCurrentContent().hasText()) {
    //   setEditorState(EditorState.createEmpty())
    //   form.setFieldValue(name, "");
    //   return;
    // }
    setEditorState(newState);
    // Convert content to HTML
    const rawContent = convertToRaw(newState.getCurrentContent());
    const htmlContent = draftToHtml(rawContent);

    console.log("HTML content:", htmlContent);
    // console.log('Decode HTML content:', decodeURIComponent(htmlContent));

    // Update Formik state with HTML content
    form.setFieldValue(name, htmlContent);
    form.setFieldTouched(name, true);
  };

  return (
    <div >
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "list",
            "textAlign",
            "link",
            "image",
            "history",
          ],
          inline: { options: ["bold", "italic", "underline", "strikethrough"] },
          blockType: {
            options: ["Normal", "H1", "H2", "H3", "Blockquote"],
          },
          list: { options: ["unordered", "ordered"] },
          textAlign: { options: ["left", "center", "right", "justify"] },
        }}
        placeholder="Enter the description here"
      />
      {/* {
        errors.description && touched.description ? <span className="invalid-feedback">{errors.description}</span> : ""
      } */}
    </div>
  );
};

export default RichTextEditor;
